export default 'SPAuth'
